module.exports = __webpack_public_path__ + "static/media/wskazowki_do_zadan_i_filmy_z_rozwiazaniami.0a10a678.svg";